export default "__VITE_ASSET__DgJsthSC__"